import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    maxHeight: 350,
    minWidth: 300,
    maxWidth: 350,
    // padding: theme.spacing(1),
    overflowY: 'auto',
    ...theme.scrollbarStyles
  },
  notificationType: {
    // marginBottom: theme.spacing(2)
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '4px 8px 2px'
  },

  badgeCountTotal: {
    '& span': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },

  noNotifications: {
    fontSize: '12px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  notificationButton: {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },

  taskTitle:{
    color: theme.palette.red_100.main
  }
}))
